import React from "react";
import { Grid, Stack } from "@mui/material";
import Icon from "src/components/icon";
import styled from "styled-components";
import Link from "src/components/link";
import GoogleButton from "react-google-button";
import { Helmet } from "react-helmet";
import googleWorkspace from "../../../assets/icons/google-workspace";
import request from "../../../utils/request";

const H1 = styled.h1`
    font-size: 22px;
    margin: 0;
    font-weight: normal;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const H2 = styled.h2`
    font-size: 14px;
    font-weight: normal;
    margin: 0;
    color: ${({ theme }) => theme.palette.primary.main};
`;

const P = styled.h2`
    font-size: 12px;
    font-weight: normal;
    margin: 0;
    ${({ theme }) => theme.breakpoints.up("sm")} {
        width: 50%;
    }
    color: ${({ theme }) => theme.palette.secondary.main};
`;

const PermissionsIcon = styled(Icon)`
    background-color: #fff;
    border-radius: 16px;
    padding: 24px 12px 24px 12px;
    margin: 32px 0 32px 0;
`;

const handleClick = async () => {
    const { oauthUrl } = await request("api/google/oauth-url");
    window.location.replace(oauthUrl);
};

const ContactPlaceholder =
    "In case of any inquiry regarding software permissions, please do not hesitate to ";

const PermissionsGoogle = () => {
    return (
        <>
            <Helmet>
                <title>Adadot - Google Permissions</title>
            </Helmet>
            <Grid container justifyContent="center" mb={4}>
                <Stack
                    direction="column"
                    alignItems="flex-start"
                    style={{ height: "100%", width: "70%" }}
                >
                    <H1>Google Integration</H1>
                    <H2>How adadot handles your Google data</H2>
                    <PermissionsIcon svg={googleWorkspace} width="100px" height="127" />
                    <P style={{ marginTop: "12px" }}>
                        {ContactPlaceholder}
                        <Link to="/upgrade/inquiry">contact us</Link>
                    </P>
                    <GoogleButton style={{ marginTop: "32px" }} onClick={handleClick} />
                </Stack>
            </Grid>
        </>
    );
};

export default PermissionsGoogle;
